import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { LocalStorageService } from '@services/local-storage.service';

/**
 * Guard that redirects unauthenticated users from the old itinerary page
 * to the new service request details page. (Basically it's the v2 of the itinerary page)
 * @param route - the current route snapshot.
 */
export const ItineraryGuestRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot): UrlTree | boolean => {
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);

  const isLoggedIn = localStorageService.isLoggedIn();

  if (isLoggedIn) {
    return true;
  } else {
    const serviceRequestId = route.params.serviceRequestId;

    if (serviceRequestId) {
      return router.createUrlTree(['/v2/service-request-details/' + serviceRequestId]);
    }

    return false;
  }
};
